import { configureStore as toolkitConfigureStore } from "@reduxjs/toolkit";
import rootReducer from "../reducers";

export default function configureStore(preloadedState: any) {
  return toolkitConfigureStore({
    reducer: rootReducer,
    preloadedState,
    devTools: true,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          // breadCrumbData items may carry render/handler functions (BreadCrumbItem.template) — e.g. the
          // FileExplorer folder breadcrumbs whose crumbs render a clickable node that navigates the tree.
          ignoredPaths: ["fileUploadList", "currentFileUploadProperties", "fileUploadProperties", "breadCrumbData"],
          ignoredActions: [
            "fileUploadList/setFileUploadData",
            "fileUploadList/updateFileUploadData",
            "breadCrumbData/setBreadCrumbData",
          ],
        },
      }),
  });
}
